<template>
	<el-dialog
		:title="translations.labels.addMedia"
		@closed="closedUploadDialog"
		:visible.sync="show"
		:show-close="false"
		:close-on-press-escape="false"
		:close-on-click-modal="false"
		width="400px"
	>
		<div class="margin-bottom-20">
			{{ translations.messages.warningUploadImageVideo }}
		</div>
		<el-upload
			:class="{ 'uploaded' : uploaded }"
			:action="upload.path"
			:headers="upload.headers"
			:data="upload.meta"
			:before-upload="beforeUpload"
			:on-change="afterChange"
			:on-success="uploadSuccess"
			:on-error="uploadFail"
			:on-remove="removeFile"
			:auto-upload="false"
			:multiple="false"
			:limit="1"
			ref="upload"
			accept="image/*, video/mp4"
			drag
		>
			<i class="el-icon-upload" />
			<div class="el-upload__text">
				{{ translations.labels.dropFile }}
			</div>
		</el-upload>
		<div slot="footer" class="dialog-footer">
			<el-button
				@click="uploadSubmit()"
				:loading="processing"
				:disabled="isDisabled"
				:type="isDisabled ? 'info' : 'primary'"
				plain
			>
				{{ translations.labels.upload }}
			</el-button>
			<el-button
				@click="closeUploadDialog()"
				plain
			>
				{{ translations.labels.cancel }}
			</el-button>
		</div>
	</el-dialog>
</template>

<script>
import { EventBus } from '@/services/event-bus'

export default {
	props: {
		show: Boolean
	},
	data () {
		return {
			processing: false,
			type: null,
			upload: {
				path: '',
				headers: {
					Application: this.$store.state.axiosToken,
					Authorization: `Bearer ${this.$store.state.auth.access_token}`,
					TeamId: this.$store.state.userTeam.id
				},
				meta: {
					videoLength: null
				}
			},
			uploaded: false
		}
	},
	computed: {
		isDisabled () {
			return !this.type
		}
	},
	methods: {
		closeUploadDialog () {
			this.processing = false
			EventBus.$emit('close-upload')
		},
		closedUploadDialog () {
			this.$refs.upload.clearFiles()
			this.upload.path = ''
			this.upload.meta = {
				videoLength: null
			}
			this.uploaded = false
			this.type = null
		},
		afterChange (file) {

			this.uploaded = true
			this.type = file.raw.type === 'video/mp4' ? 'videos' : 'images'
			this.upload.path = `${this.$config.api}/media/${this.type}`

			if (this.type === 'videos') {
				if (document.getElementById('temp')) {
					document.getElementById('temp').remove()
				}
				let video = document.createElement('video')
				video.id = 'temp'
				video.src = URL.createObjectURL(file.raw)
				video.onloadedmetadata = () => {
					this.upload.meta.videoLength = video.duration
				}
			}
		},
		beforeUpload (file) {
			this.processing = true
			if (file.size / 1024 / 1024 > process.env.VUE_APP_UPLOAD_SIZE) {
				this.processing = false
				return false
			}
		},
		removeFile () {
			this.uploaded = false
		},
		uploadSubmit () {
			this.$refs.upload.submit()
		},
		uploadSuccess (response) {
			EventBus.$emit('upload-success', {
				object: response,
				type: this.type
			})
			this.closeUploadDialog()
		},
		uploadFail () {
			setTimeout (() => {
				this.displayMessage(this.translations.statusCodes['default'], 'error')
				this.processing = false
			}, 200)
		}
	}
}
</script>

<style lang="scss">
.uploaded {

	.el-upload {
		display: none !important;
	}

}
</style>
